import { useAppForm } from "@shared/lib/form";
import { Card } from "@shared/ui/card";
import type { JSX } from "react";
import { useIntl } from "react-intl";
import { createLoginSchema } from "./login-schema";
import { useSignIn } from "./use-auth";

const defaultUser = {
	email: "bertaevwf@gmail.com",
	password: "123456",
};

export function LoginForm(): JSX.Element {
	const intl = useIntl();
	const login = useSignIn();
	const formSchema = createLoginSchema(intl);

	const form = useAppForm({
		defaultValues: defaultUser,
		validators: {
			onChange: formSchema,
			onSubmit: formSchema,
		},
		onSubmit: ({ value }) => {
			login.mutate(value);
		},
	});

	return (
		<Card className="mt-8 p-6 w-full">
			<form
				className="space-y-5"
				onSubmit={(e) => {
					e.preventDefault();
					form.handleSubmit();
				}}
			>
				<form.AppField name="email">
					{(field) => (
						<field.EmailField
							label={intl.formatMessage({
								id: "page.profile.general.email",
								defaultMessage: "Email",
							})}
						/>
					)}
				</form.AppField>
				<form.AppField name="password">
					{(field) => (
						<field.PasswordField
							label={intl.formatMessage({
								id: "form.field.password.label",
								defaultMessage: "Password",
							})}
						/>
					)}
				</form.AppField>

				<form.AppForm>
					<form.SubmitButton
						isLoading={login.isPending}
						title={intl.formatMessage({
							id: "form.submit.title",
							defaultMessage: "Sign in",
						})}
						loadingTitle={intl.formatMessage({
							id: "form.submit.loading",
							defaultMessage: "Sign in...",
						})}
						className="w-full"
					/>
				</form.AppForm>
			</form>
		</Card>
	);
}
